module.exports = __webpack_public_path__ + "img/contribute-dark.ad62c69a.svg";